// Wellesley College's majors (#2739). Read on 2026-10-01 from Wellesley's
// official Programs of Study listing (wellesley.edu/programs-of-study,
// rendered in a browser), which tags each program MAJOR, MINOR or both:
// every program tagged MAJOR is kept, named as the listing names it.
// Minor-only programs and course-only offerings (Arabic, Chinese, the
// Calderwood Seminars and others) are left out. The listing gives no degree
// per major; Wellesley awards the bachelor of arts.
const majors = {
    "slug": "wellesley-college",
    "read": "2026-10-01",
    "intro": "Every program Wellesley lists as a major on its official Programs of Study page. Minors are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Wellesley College, Programs of Study",
                "url": "https://www.wellesley.edu/programs-of-study"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemical Physics",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": null
                },
                {
                    "name": "Classical Civilization",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Cognitive and Linguistic Sciences",
                    "degree": null
                },
                {
                    "name": "Comparative Literary Studies",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": null
                },
                {
                    "name": "East Asian Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education Studies",
                    "degree": null
                },
                {
                    "name": "English and Creative Writing",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": null
                },
                {
                    "name": "French Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Geosciences",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "International Relations - Economics",
                    "degree": null
                },
                {
                    "name": "International Relations - History",
                    "degree": null
                },
                {
                    "name": "International Relations - Political Science",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics & Statistics",
                    "degree": null
                },
                {
                    "name": "Media Arts and Sciences",
                    "degree": null
                },
                {
                    "name": "Medieval and Renaissance Studies",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Peace and Justice Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Russian Area Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "South Asia Studies",
                    "degree": null
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre Studies",
                    "degree": null
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
